import styled from 'styled-components';

const ToolButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  background: ${props => props.background};
  border: 0;
  font-size: 20px;
  outline: none;
  > i, svg {
    color: white;
    opacity: 0.5;
    box-sizing: content-box;
  }

  &:hover, &:active {
    cursor: pointer;
    > i, svg {
      padding: 5px;
      background: rgba(255, 255, 255, 0.2);
      opacity: 1;
      border-radius: 2px;
    }
  }

  &:disabled, &:disabled:hover {
    cursor: not-allowed;
    > i, svg {
      padding: 0;
      background: none;
      opacity: 0.2;
      border-radius: 0;
    }
  }
`;

export default ToolButton;
